import React from "react";
import useDocumentTitle from "../../assets/utils/useDocumentTitle";
import { Breadcrumb, Footer, Header, Sidebar } from "../../components";
import "./style.scss";

function JPrestoran() {
  useDocumentTitle("Pajak Restora- BAPENDA BEKASI");
  return (
    <div className="page">
      <Header active="JPrestoran" />

      {/* main */}
      <main className="main-sb">
        <section className="content">
          <Breadcrumb path="Jenis Pelayanan / Pajak Restoran" />
          <div className="page-title-wrapper">
            <div className="page-title">PBJT Atas Makanan dan Minuman</div>
          </div>

          {/* <p className="page-text">
          </p> */}

          <p className="subpage-title"><strong>PBJT Atas Makanan dan Minuman</strong></p>
          <p className="page-text">Makanan dan/atau Minuman adalah makanan dan/atau minuman yang
disediakan, dijual dan/atau diserahkan, baik secara langsung maupun
tidak langsung, atau melalui pesanan oleh restoran. Makanan dan/atau Minuman termasuk dalam jenis Pajak Barang dan Jasa Tertentu yang selanjutnya disingkat PBJT adalah Pajak yang dibayarkan oleh konsumen akhir atas konsumsi barang dan/atau jasa tertentu. Barang dan Jasa Tertentu adalah barang dan jasa tertentu yang dijual
dan/atau diserahkan kepada konsumen akhir.
</p>
<p>
Penjualan dan/atau penyerahan Makanan dan/atau Minuman meliputi Makanan
dan/atau Minuman yang disediakan oleh:<br></br>
A. Restoran yang paling sedikit menyediakan layanan penyajian Makanan
dan/atau Minuman berupa meja, kursi, dan/atau peralatan makan dan
minum;
<br></br>
B. penyedia jasa boga atau katering yang melakukan:<br></br>
1. proses penyediaan bahan baku dan bahan setengah jadi, pembuatan,
penyimpanan, serta penyajian berdasarkan pesanan;<br></br>
2. penyajian di lokasi yang diinginkan oleh pemesan dan berbeda
dengan lokasi dimana proses pembuatan dan penyimpanan
dilakukan; dan<br></br>
3. penyajian dilakukan dengan atau tanpa peralatan dan petugasnya.
<br></br>
<p className="page-text"></p>
Dasar pengenaan PBJT adalah jumlah yang dibayarkan oleh konsumen
barang atau jasa tertentu :<br></br>
a. jumlah pembayaran yang diterima oleh penyedia Makanan dan/atau
Minuman untuk PBJT atas Makanan dan/atau Minuman;<br></br>
b. Dalam hal pembayaran menggunakan voucer atau bentuk lain yang sejenis yang memuat nilai rupiah atau mata
uang lain, dasar pengenaan PBJT ditetapkan sebesar nilai rupiah atau
mata uang lainnya tersebut;<br></br>
c. Dalam hal tidak terdapat pembayaran, dasar pengenaan PBJT dihitung berdasarkan harga jual barang dan
jasa sejenis yang berlaku di wilayah Daerah.<br></br>

Tarif PBJT atas Makanan dan/atau Minuman ditetapkan sebesar 10%
(sepuluh persen)<br>
</br>


</p>

<br></br>
<p className="page-text">
DASAR HUKUM : <br></br>
<a href="https://jdih.bekasikota.go.id/peraturan-daerah/view?id=525" target="_blank" rel="noreferrer"><font color="blue">Peraturan Daerah Kota Bekasi Nomor 1 Tahun 2024 Tentang Pajak Daerah Dan Retribusi Daerah</font></a>
</p>
         
        
         
         
          
        </section>
        <Sidebar />
      </main>

      <Footer />
    </div>
  );
}

export default JPrestoran;
